import Sider, { SiderContext } from 'antd/es/layout/Sider';
import { ConfigContext } from '../config-provider';
import AnimationContext from '../config-provider/AnimationContext';
import classNames from 'classnames';
import React from 'react';
// export default Sider;
export { SiderContext };
// eslint-disable-next-line react/display-name
const BdSider = React.forwardRef((props, ref) => {
    const { prefixCls, className, ...otherProps } = props;
    const animation = React.useContext(AnimationContext);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const classPrefix = getPrefixCls('layout-sider', prefixCls);
    const classString = classNames(classPrefix, { [`${classPrefix}-breathing`]: !!animation?.breathing }, className);
    return React.createElement(Sider, { ref: ref, prefixCls: classPrefix, className: classString, ...otherProps });
});
export default BdSider;
